import React from 'react';
import { Box } from '@mui/material';
import { capitalizeFirstletter } from '../../../utils/helper';
import { getStatusColor } from '../../catalog/utils/inventory/utils';

interface BaseExport {
  id: number;
  exportType: string;
  status: string;
}

export const renderExports = (exports: BaseExport[]) => {
  if (exports.length === 0) {
    return <Box>—</Box>;
  }

  if (exports.length === 1) {
    return (
      <Box sx={{ color: getStatusColor(exports[0].status), whiteSpace: 'nowrap' }}>
        {capitalizeFirstletter(exports[0].exportType)}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: 0.5, whiteSpace: 'nowrap' }}>
      {exports.map((exportItem, index) => (
        <Box key={exportItem.id} sx={{ color: getStatusColor(exportItem.status) }}>
          {index > 0 && ', '}
          {capitalizeFirstletter(exportItem.exportType)}
        </Box>
      ))}
    </Box>
  );
};
